import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e726456e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  disabled: ""
}
const _hoisted_2 = ["value"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 2,
  class: "form-help"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dp_field = _resolveComponent("dp-field")!
  const _component_dp_error_message = _resolveComponent("dp-error-message")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dp-input mb-3", {
        'clearable': _ctx.canClear,
        'can-be-cleared': _ctx.canClear && _ctx.modelValue,
        'form-floating': _ctx.isFloating,
        'has-error': _ctx.errors[_ctx.name],
      }])
  }, [
    _createVNode(_component_dp_field, {
      ref: "internalField",
      name: _ctx.name,
      label: _ctx.label,
      rules: _ctx.rules,
      as: "select",
      "aria-label": 'Select ' + _ctx.name,
      class: _normalizeClass(["form-select", {
          'form-select-sm': (_ctx.inputSize === _ctx.enums.inputSizeEnum.SM),
          'form-select-lg': (_ctx.inputSize === _ctx.enums.inputSizeEnum.LG),
          'is-invalid': _ctx.errors[_ctx.name],
        }]),
      id: _ctx.name,
      modelValue: _ctx.modelValue,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      "validate-on-input": _ctx.validateOnInput,
      "validate-on-change": _ctx.validateOnChange,
      "validate-on-blur": _ctx.validateOnBlur,
      "onUpdate:modelValue": _ctx.updateValue
    }, {
      default: _withCtx(() => [
        (_ctx.selectText)
          ? (_openBlock(), _createElementBlock("option", _hoisted_1, _toDisplayString(_ctx.selectText), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: option.code,
            value: option.code,
            class: "fw-700"
          }, _toDisplayString(option.description), 9, _hoisted_2))
        }), 128))
      ]),
      _: 1
    }, 8, ["name", "label", "rules", "aria-label", "class", "id", "modelValue", "placeholder", "disabled", "validate-on-input", "validate-on-change", "validate-on-blur", "onUpdate:modelValue"]),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.name,
          class: "form-label"
        }, _toDisplayString(_ctx.label), 9, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.canClear && _ctx.modelValue)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.updateValue(null)), ["prevent"])),
          class: "btn-close",
          type: "reset"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_dp_error_message, {
      class: "invalid-feedback d-block",
      name: _ctx.name
    }, null, 8, ["name"]),
    (_ctx.help)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.help), 1))
      : _createCommentVNode("", true)
  ], 2))
}